"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const cameraRenderGetOnQrCallback_1 = __importDefault(require("../../../shared/cameraRenderGetOnQrCallback"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const computeComplexUnit_1 = __importDefault(require("../../../ControlStyleFormaters/shared/computeComplexUnit"));
const CameraViewRenderer = ({ cameraControl, }) => {
    var _a, _b, _c, _d, _e;
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const cameraRef = (0, react_1.useRef)(null);
    const events = (0, useControlEvents_1.default)(cameraControl);
    (0, useOnLoad_1.default)(cameraControl, events);
    (0, react_1.useEffect)(() => {
        if (!cameraControl.takePhoto || !cameraRef.current) {
            return;
        }
        cameraRef.current.takePhoto()
            .then((photoUri) => {
            if (events.onTakePicture) {
                events.onTakePicture(photoUri);
            }
            processor.root.updateControlById({
                control: cameraControl,
                dataToUpdate: {
                    takePhoto: undefined,
                },
            });
        });
    }, [cameraControl, events, processor]);
    (0, react_1.useEffect)(() => {
        const camera = cameraRef.current;
        if (!cameraControl.startRecord
            || !camera) {
            return;
        }
        processor.root.updateControlById({
            control: cameraControl,
            dataToUpdate: {
                startRecord: undefined,
            },
        });
        camera.startRecordingVideo()
            .then((videoUri) => {
            if (events.onStartRecord) {
                events.onStartRecord(videoUri);
            }
            if (events.onStopRecord) {
                events.onStopRecord(videoUri);
            }
        });
    }, [cameraControl, events, processor]);
    (0, react_1.useEffect)(() => {
        if (!cameraControl.stopRecord || !cameraRef.current) {
            return;
        }
        processor.root.updateControlById({
            control: cameraControl,
            dataToUpdate: {
                stopRecord: undefined,
            },
        });
        cameraRef.current.stopRecordingVideo();
    }, [cameraControl, events, processor]);
    const onReadAnyCode = (0, cameraRenderGetOnQrCallback_1.default)({
        onBarCodeRead: events.onBarCodeRead,
        onQRCodeRead: events.onQRCodeRead,
    });
    return (react_1.default.createElement(Render.CameraView, { ref: cameraRef, device: (_a = cameraControl.type) !== null && _a !== void 0 ? _a : 'back', style: {
            width: (_c = (0, computeComplexUnit_1.default)((_b = cameraControl.style) === null || _b === void 0 ? void 0 : _b.width)) !== null && _c !== void 0 ? _c : '0%',
            height: (_e = (0, computeComplexUnit_1.default)((_d = cameraControl.style) === null || _d === void 0 ? void 0 : _d.height)) !== null && _e !== void 0 ? _e : '0%',
        }, isTorchOn: false, zoom: 0, onCodeReaded: onReadAnyCode }));
};
exports.default = CameraViewRenderer;
